import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {graphql, withApollo} from 'react-apollo';
import {clearImpersonationToken, setImpersonationToken} from '../../utils/ajax';
import {VERIFY_IMPERSONATION_TOKEN} from '../../api/impersonation/queries';


class Impersonation extends React.Component {
    constructor(props) {
        super(props);

        // When this component is created, previous impersonation token are cleared.
        clearImpersonationToken();
    }

    getTokenFromParams = () => {
        const {params} = this.props.match;

        return params && params.token ? params.token : null;
    };

    componentDidMount() {
        const token = this.getTokenFromParams();

        if (!token) {
            return this.handleInvalidToken();
        }

        this.props.verifyImpersonationToken(token).then(({data}) => {

            if (data.verifyImpersonationToken.ok) {
                this.initImpersonation(token);
            }

            else {
                this.handleInvalidToken();
            }
        }).catch(error => {
            console.log(error);
            this.handleInvalidToken();
        });
    }

    initImpersonation = (token) => {
        setImpersonationToken(token);
        this.props.client.resetStore();
        window.location.replace('/o');
    };

    handleInvalidToken = () => {
        window.location.replace('/o');
    };

    render() {

        return null;
    }
}

Impersonation.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.object
    }),
    client: PropTypes.shape({
        resetStore: PropTypes.func
    }),
    verifyImpersonationToken: PropTypes.func.isRequired
};


export default graphql(VERIFY_IMPERSONATION_TOKEN, {
    props: ({ mutate }) => ({
        verifyImpersonationToken: (token) => mutate({variables: {token}})
    })
})(withRouter(withApollo(Impersonation)));

